import React from 'react';
import { Grid } from '@mui/material';
import {
    GenderPicker,
    ClientLifeStageOptionPicker,
    FinancialTargetPicker,
    FinancialInterestPicker,
    DISCPicker,
    HobbiesPicker,
    ChatPurposePicker,
    LanguagePicker
} from '../../../Inputs/Inputs';

export const StandardForm = ({
    intl,
    inputOptions,
    onValueChange,
    onTraitsChange,
    client,
    children
}) => {
    return (
        <>
            {!client && (
                <GenderPicker intl={intl} options={inputOptions} onValueChange={onValueChange} />
            )}
            <ClientLifeStageOptionPicker intl={intl} options={inputOptions} onValueChange={onValueChange} />
            <FinancialTargetPicker intl={intl} options={inputOptions} onValueChange={onValueChange} />
            <FinancialInterestPicker intl={intl} options={inputOptions} onValueChange={onValueChange} />
            <Grid>
                <DISCPicker
                    intl={intl}
                    inputOptions={inputOptions}
                    onTraitsChange={onTraitsChange}
                />
            </Grid>
            <HobbiesPicker intl={intl} options={inputOptions} onValueChange={onValueChange} />
            <ChatPurposePicker intl={intl} options={inputOptions} onValueChange={onValueChange} />
            <LanguagePicker intl={intl} options={inputOptions} onValueChange={onValueChange} />
            {children}
        </>
    );
};

export default StandardForm;
